import { RestartAlt } from "@mui/icons-material";
import {
  Alert,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Snackbar,
  Typography,
} from "@mui/material";
import { useFormikContext } from "formik";
import * as React from "react";
import AppContext from "../../../../AppContext";
import { initialDetailsValues } from "../../../../components/purchase/PurchaseData.interface";
import { FullQuoteResult } from "../../../../components/quote/QuoteData.interface";
interface Props {
  setQuoteData: React.Dispatch<
    React.SetStateAction<Partial<FullQuoteResult> | null>
  >;
}

const ResetButton = ({ setQuoteData }: Props): JSX.Element => {
  const [open, setOpen] = React.useState(false);
  const appState: any = React.useContext(AppContext);
  const {
    values,
    errors,
    touched,
    isSubmitting,
    isValidating,
    setValues,
    setTouched,
    setFormikState,
  } = useFormikContext();

  const [openSnackbar, setOpenSnackbar] = React.useState(false);

  const handleOpenModal = () => {
    setOpen(true);
  };

  const handleCloseModal = () => {
    setOpen(false);
  };

  const handleOpenSnackbar = () => {
    setOpenSnackbar(true);
  };

  const handleCloseSnackbar = () => {
    setOpenSnackbar(false);
  };

  const resetQuote = async () => {
    appState.setAppState({
      ...appState.state,
      quoteRequestData: {},
    });

    setQuoteData(null);

    setFormikState({
      submitCount: 0,
      values: values,
      errors: errors,
      touched: touched,
      isSubmitting: isSubmitting,
      isValidating: isValidating,
    });

    setValues(initialDetailsValues);
    setTouched({}, false);

    localStorage.removeItem("address-form");
    localStorage.removeItem("selected-product");
    localStorage.removeItem("quote-form");
    localStorage.removeItem("quote");

    handleOpenSnackbar();
    handleCloseModal();
  };

  return (
    <>
      <IconButton aria-label="resume" onClick={handleOpenModal}>
        <svg
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M2.5 10C2.5 11.4834 2.93987 12.9334 3.76398 14.1668C4.58809 15.4001 5.75943 16.3614 7.12987 16.9291C8.50032 17.4968 10.0083 17.6453 11.4632 17.3559C12.918 17.0665 14.2544 16.3522 15.3033 15.3033C16.3522 14.2544 17.0665 12.918 17.3559 11.4632C17.6453 10.0083 17.4968 8.50032 16.9291 7.12987C16.3614 5.75943 15.4001 4.58809 14.1668 3.76398C12.9334 2.93987 11.4834 2.5 10 2.5C7.90329 2.50789 5.89081 3.32602 4.38333 4.78333L2.5 6.66667"
            stroke="#D13333"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
          <path
            d="M2.5 2.5V6.66667H6.66667"
            stroke="#D13333"
            stroke-width="1.5"
            stroke-linecap="round"
            stroke-linejoin="round"
          />
        </svg>
      </IconButton>

      <Dialog open={open} onClose={handleCloseModal} scroll={"body"}>
        <DialogTitle>Reset Quote Information?</DialogTitle>

        <DialogContent dividers>
          <Typography variant="body1">
            Are you sure you want to reset your quote information?
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseModal}>Cancel</Button>
          <Button
            onClick={resetQuote}
            endIcon={<RestartAlt />}
            variant="contained"
            color="error"
          >
            Reset Quote
          </Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={openSnackbar}
        onClose={handleCloseSnackbar}
        autoHideDuration={6000}
      >
        <Alert
          severity={"success"}
          onClose={handleCloseSnackbar}
          variant={"filled"}
          sx={{ width: "100%" }}
        >
          Quote has been reset.
        </Alert>
      </Snackbar>
    </>
  );
};

export default ResetButton;
